import { IPromise } from 'angular';

import { IListFetcher } from '../fetchers/IListFetcher';
import { RequestHelper } from '../helpers/RequestHelper';
import { ResultHelper } from '../helpers/ResultHelper';
import { ServerApiMapper } from '../helpers/ServerModelHelper';
import { IMetricInfo } from '../models/IMetricInfo';
import { Module } from '../Module';
import { GetFieldValuesRequest } from '../ServerApi/requests/GetFieldValuesRequest';
import { GetMetricsWithSummaryDataForLuidsRequest, IGetMetricsForLuidsResult } from '../ServerApi/requests/GetMetricsWithSummaryDataForLuidsRequest';
import { IFieldValue } from '../ServerApi/types/IFieldValue';
import { MetricAllowedActions } from '../ServerApi/types/MetricAllowedActions';
import { ErrorNotifyingServer } from '../services/ErrorNotifyingServer';
import { FetcherFactory } from '../services/FetcherFactory';
import { ServerService } from '../services/ServerService';
import { IActionResource } from './Resource';
import { ResourceQuery } from './ResourceQuery';

export class Metrics implements IActionResource<MetricAllowedActions> {

  public static $inject = [
    '$q',
    '$cookies',
    'ErrorNotifyingServer',
    'FetcherFactory',
    'ServerService'
  ];

  constructor(
    private $q: ng.IQService,
    private $cookies: ng.cookies.ICookiesService,
    private ErrorNotifyingServer: ErrorNotifyingServer,
    FetcherFactory: FetcherFactory,
    private server: ServerService,
    private listFetcher: IListFetcher<IMetricInfo>,
    private allQuery: ResourceQuery<IMetricInfo>,
  // private detailFetcher: IDetailFetcher<IWorkbookDetailInfo>; 
  // we don't have metric detail yet - TFS927416
    private fieldValuesFetcher: IListFetcher<IFieldValue>,
  ) {
    this.server = ErrorNotifyingServer.getServerService();
    this.listFetcher = FetcherFactory.getServerResourceFetcher(GetMetricsWithSummaryDataForLuidsRequest, ServerApiMapper.metrics);
    this.allQuery = new ResourceQuery(this.listFetcher);
    // this.detailFetcher = FetcherFactory.getServerDetailFetcher('getMetric', MetricMapper.mapDetail);
    // we don't have metric detail yet - TFS927416
    this.fieldValuesFetcher = FetcherFactory.getServerResourceFetcher(GetFieldValuesRequest, ServerApiMapper.fieldValues);

  }

  public getMetricsByLuids(luids: string[]): ng.IPromise<IGetMetricsForLuidsResult> {
    return this.ErrorNotifyingServer.sendRequests(
      RequestHelper.buildRequests(luids, (luids) => new GetMetricsWithSummaryDataForLuidsRequest({luids})),
      (results: IGetMetricsForLuidsResult[]) => {
        return {
          errors: ResultHelper.combineErrors(results),
          metrics: ResultHelper.combine(results, (result) => result.metrics)
        };
      }
    );
  }

  public actions(id: string): ng.IPromise<MetricAllowedActions> {
    return this.$q.resolve({del: true});
  }

  public all(): ResourceQuery<IMetricInfo> {
    return this.allQuery;
  }

}

Module.instance().service('Metrics', Metrics);

